import { Outlet, Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function Layout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMenuRoute = location.pathname === "/menu" || location.pathname === "/menu/catering";
  const isCateringRoute = location.pathname === "/catering";
  const isHomeRoute = location.pathname === "/";
  const isContactRoute = location.pathname === "/contact";

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-1000 border-b border-border-default transition-colors duration-300 ${
          mobileMenuOpen ? "bg-bg-primary" : "bg-bg-primary/95 backdrop-blur-md"
        }`}
      >
        <div className="max-w-[1200px] mx-auto px-6 flex items-center justify-between h-[70px]">
          <Link
            to="/"
            className="flex items-center gap-3"
            onClick={closeMobileMenu}
          >
            <img
              src="/images/TheCanopyLogo.webp"
              alt="The Canopy"
              className="h-12 w-auto"
            />
            <span className="font-display text-xl font-semibold text-text-primary hidden sm:block">
              The Canopy
            </span>
          </Link>

          {/* Desktop Nav */}
          <ul className="hidden md:flex items-center gap-8">
            <li>
              <Link
                to="/"
                className={`text-[0.95rem] font-medium transition-colors duration-200 ${
                  isHomeRoute
                    ? "text-accent-pink"
                    : "text-text-secondary hover:text-text-primary"
                }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/menu"
                className={`text-[0.95rem] font-medium transition-colors duration-200 ${
                  isMenuRoute
                    ? "text-accent-pink"
                    : "text-text-secondary hover:text-text-primary"
                }`}
              >
                Menu
              </Link>
            </li>
            <li>
              <Link
                to="/catering"
                className={`text-[0.95rem] font-medium transition-colors duration-200 ${
                  isCateringRoute
                    ? "text-accent-pink"
                    : "text-text-secondary hover:text-text-primary"
                }`}
              >
                Catering
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`text-[0.95rem] font-medium transition-colors duration-200 ${
                  isContactRoute
                    ? "text-accent-pink"
                    : "text-text-secondary hover:text-text-primary"
                }`}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden w-10 h-10 flex flex-col justify-center items-center gap-[6px] bg-transparent border-none cursor-pointer"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span
              className={`w-6 h-[2px] bg-text-primary transition-all duration-300 ${
                mobileMenuOpen ? "rotate-45 translate-y-[8px]" : ""
              }`}
            ></span>
            <span
              className={`w-6 h-[2px] bg-text-primary transition-all duration-300 ${
                mobileMenuOpen ? "opacity-0" : ""
              }`}
            ></span>
            <span
              className={`w-6 h-[2px] bg-text-primary transition-all duration-300 ${
                mobileMenuOpen ? "-rotate-45 -translate-y-[8px]" : ""
              }`}
            ></span>
          </button>
        </div>

        {/* Mobile Menu */}
        <ul className={`mobile-menu ${mobileMenuOpen ? "active" : ""}`}>
          <li>
            <Link
              to="/"
              onClick={closeMobileMenu}
              className={`text-2xl font-medium ${
                isHomeRoute
                  ? "text-accent-pink"
                  : "text-text-primary"
              }`}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/menu"
              onClick={closeMobileMenu}
              className={`text-2xl font-medium ${
                isMenuRoute
                  ? "text-accent-pink"
                  : "text-text-primary"
              }`}
            >
              Menu
            </Link>
          </li>
          <li>
            <Link
              to="/catering"
              onClick={closeMobileMenu}
              className={`text-2xl font-medium ${
                isCateringRoute
                  ? "text-accent-pink"
                  : "text-text-primary"
              }`}
            >
              Catering
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              onClick={closeMobileMenu}
              className={`text-2xl font-medium ${
                isContactRoute
                  ? "text-accent-pink"
                  : "text-text-primary"
              }`}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      <main>
        <Outlet />
      </main>

      <footer className="bg-bg-secondary border-t border-border-default py-16">
        <div className="container">
          <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 mb-8">
            <div className="flex items-center gap-5 flex-wrap justify-center">
              <Link to="/" className="transition-opacity hover:opacity-80">
                <img
                  src="/images/TheCanopyLogo.webp"
                  alt="The Canopy"
                  className="h-16 w-auto"
                />
              </Link>
              <a
                href="https://www.bullontheloose.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-80"
              >
                <img
                  src="/images/BOTLLogo.webp"
                  alt="Bull on the Loose"
                  className="h-12 w-auto"
                />
              </a>
              <a
                href="https://retrogrillec.com"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-80"
              >
                <img
                  src="/images/RetroGrillLogo.webp"
                  alt="Retro Grill"
                  className="h-12 w-auto"
                />
              </a>
            </div>
            <div className="flex items-center gap-8 flex-wrap justify-center">
              <Link
                to="/"
                className="text-text-secondary hover:text-text-primary transition-colors"
              >
                Home
              </Link>
              <Link
                to="/menu"
                className="text-text-secondary hover:text-text-primary transition-colors"
              >
                Menu
              </Link>
              <Link
                to="/catering"
                className="text-text-secondary hover:text-text-primary transition-colors"
              >
                Catering
              </Link>
              <Link
                to="/contact"
                className="text-text-secondary hover:text-text-primary transition-colors"
              >
                Contact
              </Link>
            </div>
            <div className="text-center md:text-left">
              <p className="text-sm font-semibold uppercase tracking-[0.12em] text-accent-blue mb-1">
                Hours
              </p>
              <p className="text-text-secondary text-sm">Monday - Sunday</p>
              <p className="text-text-primary font-medium text-sm">
                10:30 AM - 9:00 PM
              </p>
            </div>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/TheCanopyEC"
                target="_blank"
                rel="noopener"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-bg-elevated text-text-secondary hover:text-accent-pink hover:bg-bg-tertiary transition-all"
              >
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/thecanopyec"
                target="_blank"
                rel="noopener"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-bg-elevated text-text-secondary hover:text-accent-pink hover:bg-bg-tertiary transition-all"
              >
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
          <div className="text-center pt-8 border-t border-border-default">
            <p className="text-text-muted text-sm">
              &copy; {new Date().getFullYear()} The Canopy. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
